









import { computed, defineComponent } from '@vue/composition-api';
import ModuleCreateFormVue from './ModuleCreateForm.vue';
import ModuleEditFormVue from './ModuleEditForm.vue';

export default defineComponent({
	props: {
		moduleId: {
			type: String,
			required: false,
			default: '',
		},
	},
	setup(props) {
		const currentComponent = computed(() => {
			if (props.moduleId) {
				return ModuleEditFormVue;
			}
			return ModuleCreateFormVue;
		});
		return {
			currentComponent,
		};
	},
});
